import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../services/api";
import PublicNav from "../components/PublicNav";
import BottomNav from "../components/BottomNav";
import { isAppWebView } from "../utils/appWebView";

const PURPLE = "#7c2d12";

function ChartsPage() {
  const navigate = useNavigate();
  const inAppWebView = isAppWebView();
  const [overview, setOverview] = useState({ markets: [], starline_markets: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const prev = document.title;
    document.title = "Satta Matka Charts | Kalyan, Milan & Rajdhani Jodi Charts";
    const desc = document.querySelector("meta[name='description']");
    const prevDesc = desc?.getAttribute("content") || "";
    desc?.setAttribute("content", "Explore the latest kalyan matka charts, milan charts, panel charts, jodi charts, and historical satta matka results updated regularly.");
    return () => {
      document.title = prev;
      if (desc) desc.setAttribute("content", prevDesc);
    };
  }, []);

  useEffect(() => {
    setLoading(true);
    API.get("/charts/overview")
      .then((res) => setOverview(res.data || { markets: [], starline_markets: [] }))
      .catch(() => setOverview({ markets: [], starline_markets: [] }))
      .finally(() => setLoading(false));
  }, []);

  const markets = useMemo(() => overview.markets || [], [overview]);
  const starlineMarkets = useMemo(() => overview.starline_markets || [], [overview]);

  return (
    <div style={page}>
      {!inAppWebView && <PublicNav />}
      <h1 style={pageTitle}>Latest Satta Matka Game Charts &amp; Live Results</h1>

      <main style={main}>
        {loading ? (
          <p style={loadingTxt}>Loading charts…</p>
        ) : (
          <>
            {starlineMarkets.length > 0 && (
              <section style={section}>
                <div style={sectionHdr}>STARLINE CHARTS</div>
                <div style={btnGrid}>
                  {starlineMarkets.map((m) => (
                    <button
                      key={m.id}
                      type="button"
                      style={mktBtn}
                      onClick={() => navigate(`/charts/starline/${m.id}`)}
                    >
                      {m.name}
                    </button>
                  ))}
                </div>
              </section>
            )}

            {markets.length > 0 && (
              <section style={section}>
                <div style={sectionHdr}>PANNA CHARTS</div>
                <div style={btnGrid}>
                  {markets.map((m) => (
                    <button
                      key={m.id}
                      type="button"
                      style={mktBtn}
                      onClick={() => navigate(`/charts/market/${m.id}?view=panel`)}
                    >
                      {m.name}
                    </button>
                  ))}
                </div>
              </section>
            )}

            {markets.length > 0 && (
              <section style={section}>
                <div style={sectionHdr}>JODI CHARTS</div>
                <div style={btnGrid}>
                  {markets.map((m) => (
                    <button
                      key={m.id}
                      type="button"
                      style={mktBtn}
                      onClick={() => navigate(`/charts/market/${m.id}?view=jodi`)}
                    >
                      {m.name}
                    </button>
                  ))}
                </div>
              </section>
            )}

            {!markets.length && !starlineMarkets.length && (
              <p style={emptyTxt}>No chart data available yet.</p>
            )}
          </>
        )}
      </main>
      <BottomNav />
    </div>
  );
}

export default ChartsPage;

const page = {
  minHeight: "100vh",
  background: "#ffffff",
  fontFamily: "Arial, Helvetica, sans-serif",
  color: "#0f172a",
  paddingBottom: 90,
};

const pageTitle = {
  margin: "16px 12px 4px",
  fontSize: 18,
  fontWeight: 900,
  color: PURPLE,
  textAlign: "center",
};

const main = {
  maxWidth: 960,
  margin: "0 auto",
  padding: "16px 12px 40px",
};

const section = { marginBottom: 8 };

const sectionHdr = {
  background: PURPLE,
  color: "#fff",
  fontWeight: 900,
  fontSize: 14,
  letterSpacing: "0.1em",
  padding: "11px 16px",
  marginBottom: 10,
};

const btnGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(130px, 1fr))",
  gap: 8,
  marginBottom: 16,
};

const mktBtn = {
  padding: "11px 8px",
  border: "1.5px solid " + PURPLE,
  borderRadius: 6,
  background: "#fff",
  color: PURPLE,
  fontWeight: 800,
  fontSize: 11,
  cursor: "pointer",
  textAlign: "center",
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  lineHeight: 1.3,
};

const loadingTxt = { textAlign: "center", padding: 32, color: PURPLE, fontWeight: 700 };
const emptyTxt   = { textAlign: "center", padding: 32, color: "#64748b", fontWeight: 700 };
